<div class="line-switcher-dialog">
    <div class="line-switcher-swap-pick__container">
        <div class="line-switcher-swap-pick__event-name">{{ event.name }}</div>
        <ng-scrollbar class="ng-scrollbar-compact" [viewportPropagateMouseMove]="false">
            <ms-option-panel [optionGroup]="optionGroup" [event]="event" [preselectedPick]="pickInfo" [toggleable]="false" [tracking]="tracking" />
        </ng-scrollbar>
    </div>
</div>
